import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILineGroup } from "src/models/Offers/MixAndMatch.models";

interface LineGroupState {
  lineGroups: ILineGroup[];
  lineGroupToEdit: ILineGroup | null;
}

const initialState: LineGroupState = {
  lineGroups: [],
  lineGroupToEdit: null,
};

const LineGroupSlice = createSlice({
  name: "LineGroup",
  initialState,
  reducers: {
    setLineGroupList: (state, action: PayloadAction<ILineGroup[]>) => {
      state.lineGroups = action.payload;
    },
    concatListLineGroup: (
      state: LineGroupState,
      action: PayloadAction<ILineGroup[]>
    ) => {
      state.lineGroups = [...state.lineGroups.concat(action.payload)];
    },
    setLineGroupToEdit: (state, action: PayloadAction<ILineGroup | null>) => {
      state.lineGroupToEdit = action.payload;
    },
    addLineGroup: (state, action: PayloadAction<ILineGroup>) => {
      state.lineGroups.push(action.payload);
    },
    updateLineGroup: (state, action: PayloadAction<ILineGroup>) => {
      let itemIndex = state.lineGroups.findIndex(
        item => item.lineGroupId === action.payload.lineGroupId
      );
      if (itemIndex !== -1) state.lineGroups[itemIndex] = action.payload;
    },
    deleteLineGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.lineGroups.filter(
        item => item.lineGroupId !== action.payload
      );
      state.lineGroups = newArray;
    },
  },
});

export const {
  setLineGroupList,
  concatListLineGroup,
  setLineGroupToEdit,
  addLineGroup,
  updateLineGroup,
  deleteLineGroup,
} = LineGroupSlice.actions;

export default LineGroupSlice.reducer;
